<script setup lang="ts">
import type { ButtonSize } from '@/types/button'

defineProps<{
  size: ButtonSize
}>()

const spinnerSizeMap = {
  xs: 'h-3 w-3',
  sm: 'h-4 w-4',
  md: 'h-[18px] w-[18px]',
  lg: 'h-[18px] w-[18px]',
  square: 'h-5 w-5',
} as const
</script>

<template>
  <span
    class="spinner-container"
    :class="[spinnerSizeMap[size]]"
    role="status"
    aria-label="Loading"
  >
    <svg
      class="absolute inset-0 w-full h-full text-current transition-opacity duration-300 animate-spin"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
      <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  </span>
</template>

<style scoped>
.spinner-container {
  @apply inline-flex relative justify-center items-center transition-all duration-300 ease-out origin-center;
}
</style>
